var exports = {
  "Q": "x93eb46d8--85690e--content",
  "n": "x93eb46d8--85690e--controls",
};

module.exports = exports;
